import { render, staticRenderFns } from "./rh_dashboard_colaborador.vue?vue&type=template&id=b77dc868&scoped=true&"
import script from "./rh_dashboard_colaborador.vue?vue&type=script&lang=js&"
export * from "./rh_dashboard_colaborador.vue?vue&type=script&lang=js&"
import style0 from "./rh_dashboard_colaborador.vue?vue&type=style&index=0&id=b77dc868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77dc868",
  null
  
)

export default component.exports